//数据表格配置

import tool from '@/utils/tool'

export default {
	successCode: 200,												//请求完成代码
	pageSize: 20,													//表格每一页条数
	pageSizes: [10, 20, 30, 40, 50],								//表格可设置的一页条数
	paginationLayout: "total, sizes, prev, pager, next, jumper",	//表格分页布局，可设置"total, sizes, prev, pager, next, jumper"
	parseData: function (res) {										//数据分析
		return {
			data: res.items, // 无分页时的字段
			rows: res.items, // 分页时的行数据字段
			total: res.totalCount, // 总数字段
			summary: res.summary || {}, // 合计行字段（保持兼容性）
			msg: res.message || '', // 错误消息字段
			code: res.code || 200 // 状态字段（假设 HTTP 200）
		}
	},
	request: {							//请求规定字段
		page: 'SkipCount', // ABP 分页参数：跳过的记录数
		pageSize: 'MaxResultCount', // ABP 分页参数：每页最大记录数
		sorting: 'Sorting' // ABP 排序参数
	},
	/**
	 * 自定义列保存处理
	 * @tableName scTable组件的props->tableName
	 * @column 用户配置好的列
	 */
	columnSettingSave: function (tableName, column) {
		return new Promise((resolve) => {
			setTimeout(() => {
				//这里为了演示使用了session和setTimeout演示，开发时应用数据请求
				tool.session.set(tableName, column)
				resolve(true)
			}, 1000)
		})
	},
	/**
	 * 获取自定义列
	 * @tableName scTable组件的props->tableName
	 * @column 组件接受到的props->column
	 */
	columnSettingGet: function (tableName, column) {
		return new Promise((resolve) => {
			//这里为了演示使用了session和setTimeout演示，开发时应用数据请求
			const userColumn = tool.session.get(tableName)
			if (userColumn) {
				resolve(userColumn)
			} else {
				resolve(column)
			}
		})
	},
	/**
	 * 重置自定义列
	 * @tableName scTable组件的props->tableName
	 * @column 组件接受到的props->column
	 */
	columnSettingReset: function (tableName, column) {
		return new Promise((resolve) => {
			//这里为了演示使用了session和setTimeout演示，开发时应用数据请求
			setTimeout(() => {
				tool.session.remove(tableName)
				resolve(column)
			}, 1000)
		})
	}
}
